<section class="p-5 lg:p-10">
  <div class="max-w-screen-xl mx-auto flex flex-col gap-6">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 class="text-2xl font-bold text-chathams-blue">Questionários</h1>
        <p class="text-gray-500 text-sm">
          Consulte os roteiros disponíveis para a empresa selecionada e acompanhe o status de publicação.
        </p>
      </div>
      <a
        *isAllowed="[ERoleAdminString.Admin, ERoleAdminString.QuestionnaireAdmin, 'questionnaire.create']"
        routerLink="/dash/questionarios/personalizados"
        class="btn btn--secondary h-10 flex items-center justify-center gap-2"
      >
        <span class="text-lg leading-none">+</span>
        <span>Criar questionário personalizado</span>
      </a>
    </div>

    <div class="flex flex-col gap-4 bg-white rounded-lg shadow p-5 border border-gray-100">
      <div class="flex flex-col md:flex-row gap-4">
        <input
          [formControl]="acaoInput"
          type="text"
          class="form-input md:flex-1"
          placeholder="Pesquise por nome ou palavra-chave"
        />

        <select class="form-select md:w-60" [formControl]="ordenarControl">
          <option disabled value="">Ordenar</option>
          <option *ngFor="let order of opcoesOrdenacao" [value]="order.value">{{ order.label }}</option>
        </select>

        <div class="flex gap-3">
          <button class="btn btn--secondary h-10 px-6" (click)="filtrarFilial()">Filtrar</button>
          <button class="btn btn--primary h-10 px-6 bg-blumine" (click)="limparFiltros()">Limpar</button>
        </div>
      </div>
    </div>

    <app-list-questionarios
      [questionarios]="questionarios"
      [dadosPaginacao]="dadosPaginacao"
      (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
      (recarregarListagem)="carregarQuestionarios()"
    >
    </app-list-questionarios>
  </div>
</section>
